import { ActivityType, VarianceType } from '@shared/services/gql.service';

export const DEFAULT_ANALYTIC_CARDS = [
  {
    differenceAmount: 0,
    differencePerc: 0,
    title: 'Total Forecast Variance (BvA)',
  },
  {
    differenceAmount: 0,
    differencePerc: 0,
    title: 'Services Forecast Variance',
  },
  {
    differenceAmount: 0,
    differencePerc: 0,
    title: 'Investigator Forecast Variance',
  },
  {
    differenceAmount: 0,
    differencePerc: 0,
    title: 'Pass Through Forecast Variance',
  },
  {
    differenceAmount: 0,
    differencePerc: 0,
    title: 'Largest Activity Variance $',
  },
  {
    differenceAmount: 0,
    differencePerc: 0,
    title: 'Largest Activity Variance %',
  },
  {
    differenceAmount: 0,
    differencePerc: 0,
    title: 'Largest Unit Cost Variance',
  },
  {
    differenceAmount: 0,
    differencePerc: 0,
    title: 'Largest Unit Variance',
  },
];

export const mapTitleVariancesByType = new Map<string, { title: string }>([
  [
    `${VarianceType.VARIANCE_FORECAST}_${ActivityType.ACTIVITY_INVESTIGATOR}`,
    { title: 'Investigator Forecast Variance' },
  ],
  [
    `${VarianceType.VARIANCE_FORECAST}_${ActivityType.ACTIVITY_PASSTHROUGH}`,
    { title: 'Pass Through Forecast Variance' },
  ],
  [
    `${VarianceType.VARIANCE_FORECAST}_${ActivityType.ACTIVITY_SERVICE}`,
    { title: 'Services Forecast Variance' },
  ],
  [VarianceType.VARIANCE_ACTIVITY_AMOUNT_PERCENTAGE, { title: 'Largest Activity Variance %' }],
  [VarianceType.VARIANCE_ACTIVITY_AMOUNT_TOTAL, { title: 'Largest Activity Variance $' }],
  [VarianceType.VARIANCE_ACTIVITY_UNIT_COST, { title: 'Largest Unit Cost Variance' }],
  [VarianceType.VARIANCE_ACTIVITY_UNITS, { title: 'Largest Unit Variance' }],
  [VarianceType.VARIANCE_FORECAST, { title: 'Total Forecast Variance (BvA)' }],
]);
